/* eslint-disable jsx-a11y/anchor-has-content */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import './assets/style.scss';
import { URL_HOME, URL_AUTH } from "../../../../utils/Constant";
import { logout } from '../../../../api/app';
import { updateAuth, getAuth, getIsGuest } from '../../../../utils/localStoreHelper';
import { UserInfo } from '../UserInfo';

class Header extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dropDownOpen: {
        dimensions: false,
        ground: false,
      },
      isGuest: getIsGuest(),
      lastValidName: props.name || '',
      isInputFocused: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.isInputFocused && nextProps.name && nextProps.name.trim() !== '') {
      return { lastValidName: nextProps.name };
    }
    return null;
  }

  componentDidMount() {
    // Подписываемся на изменения LocalStorage
    window.addEventListener('storage', this.handleStorageChange);
  }

  componentWillUnmount() {
    // Удаляем слушатель storage
    window.removeEventListener('storage', this.handleStorageChange);
  }

  // Обработчик изменения LocalStorage
  handleStorageChange = (e) => {
    if (e.key === 'auth') {
      // Обновляем isGuest при изменении auth в LocalStorage
      this.setState({
        isGuest: getIsGuest()
      });
    }
  }

  toggle = (name) => {
    if (this.state) {
      this.setState({
        dropDownOpen: {
          ...this.state.dropDownOpen,
          [name]: !this.state.dropDownOpen[name]
        }
      });
    }
  }

  handleLogin = (e) => {
    e.preventDefault();
    updateAuth({token: ''});
    getAuth();
    const auth = getAuth();
    window.location.href = auth.url ? auth.url : URL_AUTH;
  }

  handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
    } catch (error) {
      console.error('Logout API error:', error);
    }
    updateAuth({token: undefined});
    window.location.reload();
  }

  renderSettingsDropDown = () => {
    return <Dropdown
      isOpen={this.state.dropDownOpen.dimensions}
      toggle={() => this.toggle('dimensions')}
      onMouseEnter={() => this.toggle('dimensions')}
      onMouseLeave={() => this.toggle('dimensions')}
    >
      <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={this.state.dropDownOpen.dimensions}>
        Размер <i className="icon-up"/>
      </DropdownToggle>

      <DropdownMenu className="Constructor-Playground-Settings">
        <span className="Constructor-Playground-Settings-Title">
          {this.props.field.width}x{this.props.field.height} м
        </span>

        <Slider
          className="Constructor-Playground-Settings-Slider"
          step={1} min={5} max={50}
          defaultValue={this.props.field.width}
          onChange={(value) => {
            this.props.updateFieldSize('width', value);
          }}
          onAfterChange={(value) => {
            this.props.updateFieldSize('width', value);
          }}
        />

        <Slider
          className="Constructor-Playground-Settings-Slider"
          step={1} min={5} max={50}
          defaultValue={this.props.field.height}
          onChange={(value) => {
            this.props.updateFieldSize('height', value);
          }}
          onAfterChange={(value) => {
            this.props.updateFieldSize('height', value);
          }}
        />

        <div style={{marginTop:'15px'}}>
          <div
            className={`Constructor-Playground-Settings-FreeTransform ${this.props.siteCustom.active ? 'Constructor-Playground-Settings-FreeTransform_active' : ''}`}>
            <label onClick={this.props.toggle}>Произвольная форма</label> <br/>
          </div>

          <div
            className={`Constructor-Playground-Settings-FreeTransform ${this.props.siteCustom.viewTop ? 'Constructor-Playground-Settings-FreeTransform_active' : ''}`}>
            <label onClick={this.props.toggleView}>Вид сверху</label>
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  };

  renderGroundDropDown = () => {
    return <Dropdown
      isOpen={this.state.dropDownOpen.ground}
      toggle={() => this.toggle('ground')}
      onMouseEnter={() => this.toggle('ground')}
      onMouseLeave={() => this.toggle('ground')}
    >
      <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={this.state.dropDownOpen.ground}>
        Основание <i className="icon-up"/>
      </DropdownToggle>

      <DropdownMenu>
        <ul className="Constructor-Playground-Settings-Ground">
          {this.props.grounds && this.props.grounds.map((ground, i) => {
            if(ground) {
              return <li onClick={() => {
                this.props.updateGround(ground.name);
              }} key={`ground${i}`} >
                <img src={ground.img.src} alt="Основание"/>
              </li>;
            }
            return null;
          })}
        </ul>
      </DropdownMenu>
    </Dropdown>
  };

  render() {
    const { isGuest } = this.state;
    
    return (
      <header className="Constructor-Header" ref='ConstructorHeaderHeader'>
        <ul>
          <li><a className="Constructor-Sidebar-Menu-Logo" href={URL_HOME} /></li>
          <li className="Constructor-Header-SearchForm">
            <input
              name='playground-Name'
              type="text"
              value={this.props.name || ''}
              onFocus={() => this.setState({ lastValidName: this.props.name || '', isInputFocused: true })}
              onBlur={(e) => {
                this.setState({ isInputFocused: false });
                const value = e.target.value.trim();
                if (value === '') {
                  this.props.onNameChange && this.props.onNameChange(this.state.lastValidName);
                } else {
                  this.setState({ lastValidName: value });
                }
              }}
              onChange={(e) => this.props.onNameChange && this.props.onNameChange(e.target.value)}
            />
          </li>
          <li onClick={this.props.newPlayground}><i className="icon-page"/>Очистить</li>
          <li><i className="icon-playground"/> {this.renderSettingsDropDown()} </li>
          <li><i className="icon-playground"/> {this.renderGroundDropDown()} </li>

          <li onClick={(e) => {
            this.props.saveAs('pdf');
          }}><i className="icon-email"/> Сохранить в pdf</li>
          <li onClick={(e) => {
            this.props.saveAs('jpg');
          }}><i className="icon-download"/> Сохранить в jpg</li>

          <li onClick={this.props.toggleView}>Вид сверху</li>
          
          {isGuest ? (
            <li>
              <a href='/' onClick={this.handleLogin}>Войти</a>
            </li>
          ) : (
            <li>
              <UserInfo onLogout={this.handleLogout} />
            </li>
          )}
        </ul>
      </header>
    );
  }
}

Header.propTypes = {
  field: PropTypes.object.isRequired,
  grounds: PropTypes.array.isRequired,
  siteCustom: PropTypes.object.isRequired,
  updateFieldSize: PropTypes.func.isRequired,
  name: PropTypes.string,
  onNameChange: PropTypes.func,
};

export default Header;